export default "__VITE_ASSET__D8jKtAT5__"